export default {"src":"/_next/static/media/catalog-sort-btn-icon.4a985736.svg","height":16,"width":20,"blurWidth":0,"blurHeight":0};